import { render, staticRenderFns } from "./BonusTip.vue?vue&type=template&id=7e62ac6e&scoped=true&"
import script from "./BonusTip.vue?vue&type=script&lang=js&"
export * from "./BonusTip.vue?vue&type=script&lang=js&"
import style0 from "./BonusTip.vue?vue&type=style&index=0&id=7e62ac6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e62ac6e",
  null
  
)

export default component.exports